<template>
  <div class="simple-calendar">
    <div class="date-title" >
      <div>日</div>
      <div>一</div>
      <div>二</div>
      <div>三</div>
      <div>四</div>
      <div>五</div>
      <div>六</div>
    </div>
    <div class="calendar-container">
      <div class="date-container middlemonth">
        <div class="date-header">{{ middleDivCalendar.year + '年'+(middleDivCalendar.month + 1)+'月' }}</div>
        <div class="date-board">
          <div v-for="i in new Date(middleDivCalendar.year, middleDivCalendar.month, 1).getDay()" :key="-i"></div>
          <div class="date-block"
               :class="{visit: isVisitDay(i)}"
               v-for="i in getMonthDayByMonthYear (middleDivCalendar.month, middleDivCalendar.year)"
               :key="i">
            <span>{{ i }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  export default {
    props: ['visitDates'],
    data () {
      return {
        isShow: true, // 控制日历的收起与展开
        scrollTimer: null, // 滚动定时器，用于滚动事件防抖动
        middleDivCalendar: { year: 2019, month: 9 } // 中间div显示的日历
      };
    },
    mounted () {
      if (this.visitDates && this.visitDates.length > 0) {
        let day = moment(this.visitDates[0]);
        this.middleDivCalendar = { year: day.year(), month: day.month() };
      } else {
        this.middleDivCalendar = { year: new Date().getFullYear(), month: new Date().getMonth() };
      }
    },
    methods: {
      getMonthDayByMonthYear (month, year) { // 获取某年某月的天数
        // 判断是否为闰年
        const isLeap = (year % 100 === 0) ? (year % 400 === 0 ? 1 : 0) : (year % 4 === 0) ? 1 : 0;
        const monthDay = [31, 28 + isLeap, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // 数组中的每一项代表每个月的天数
        return monthDay[month];
      },
      isVisitDay(i) {
        let day = `${this.middleDivCalendar.year }-${ this.getTen(this.middleDivCalendar.month + 1) }-${ this.getTen(i)}`;
        return this.visitDates.indexOf(day) > -1;
      },
      getTen(num) {
        if (num < 10) {
          return `0${ num}`;
        }
        return `${ num}`;
      }
    }
  };
</script>

<style lang="scss" scoped>
.simple-calendar{
  .date-title {
    display: flex;
    padding: .10rem 0;
    text-align: center;
    border-bottom: .01rem solid #d1d1d1;
    div {
      flex: 1;
    }
  }
  .calendar-container{
    .date-container {
      .date-header {
        text-align: center;
        padding: .07rem 0;
        background-color: #F8F8F8;
      }
      .date-board {
        display: flex;
        display: -webkit-flex;
        flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        text-align: center;
        div {
          width: 14.28571%;
          padding: 0;
          border: 0.01rem solid #eee;
        }
        .todayBlock {
          span {
            color: red;
          }
        }
        .visit{
          background-color: #7ed321;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/SimpleCalendar.vue